// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1CUkA","detailsBorder":"styles_detailsBorder__alG4f"};